export const BASIC_TEMPLATE_FIELDS = `
  agents {
    nodes {
      id
    }
  }
  conditions {
    nodes {
      id
      param
      operator
      value
    }
  }
  createdAt
  default
  displayCountWhenInactive
  id
  locked
  matchType
  name
  position
  state
  type
  teams {
    nodes {
      id
    }
  }
  channels {
    nodes {
      id
    }
  }
  updatedAt

`

export const query = folderId => `
  query FolderQuery {
    folders(filter: { ids: ["${folderId}"] }) {
      nodes {
        ${BASIC_TEMPLATE_FIELDS}
      }
    }
  }
`

export const collectionQuery = () => `
  query FoldersQueryV2($size: Int) {
    folders(first: $size) {
      nodes {
        ${BASIC_TEMPLATE_FIELDS}
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`

export const dataTableQuery = () => `
  query FoldersDataTableQueryV2($size: Int) {
    folders(first: $size, filter: { state: ALL, scope: ALL }) {
      nodes {
        ${BASIC_TEMPLATE_FIELDS}
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
    channels(first: 1000) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
    agents(first: 1000) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
    teams(first: 1000) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`

export const getByIdsQuery = () => `
  query FoldersByIdsQueryV2($filter: FolderFilter, $cursor: String, $orderBy: FolderOrder) {
    folders(filter: $filter, after: $cursor, orderBy: $orderBy) {
      nodes {
        ${BASIC_TEMPLATE_FIELDS}
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
    agents(first: 1000) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`
